var $8f855bffe63f6eca$exports = {};
$8f855bffe63f6eca$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Reik\u0161m\u0117 turi b\u016Bti ".concat(args.maxValue, " arba ankstesn\u0117.");
  },
  "rangeReversed": "Prad\u017Eios data turi b\u016Bti ankstesn\u0117 nei pabaigos data.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Reik\u0161m\u0117 turi b\u016Bti ".concat(args.minValue, " arba naujesn\u0117.");
  },
  "unavailableDate": "Pasirinkta data nepasiekiama."
};
export { $8f855bffe63f6eca$exports as default };